import { z } from "zod";

import { InquiryEntity } from "~/entities/inquiry/model";
import { Response } from "~/shared/api";
import { withInvertedProperties } from "~/shared/record";

const zSubjectAsNumber = z.number().int().min(0).max(2);

const SUBJECT_BY_NUMBER = Object.fromEntries(
  [
    InquiryEntity.SubjectSchema.I_D_LIKE_TO_ORDER,
    InquiryEntity.SubjectSchema.SERVICE_QUESTIONS,
    InquiryEntity.SubjectSchema.OTHER,
  ].map((value, index) => [index, value]),
) as Record<number, InquiryEntity.SubjectSchema>;

const NUMBER_BY_SUBJECT = withInvertedProperties(SUBJECT_BY_NUMBER);

const zSubjectFromNumber = zSubjectAsNumber
  .transform((value) => SUBJECT_BY_NUMBER[value])
  .pipe(InquiryEntity.zSubjectSchema);

const zOutSchema = InquiryEntity.zSchema
  .pick({
    id: true,
    isResolved: true,
  })
  .extend({
    fullName: InquiryEntity.zSchema.shape.fullName.nullable(),
    message: InquiryEntity.zSchema.shape.message.nullable(),
    subject: zSubjectFromNumber,
    createdAt: z.string().datetime(),
    adminComment: InquiryEntity.zSchema.shape.adminComment.nullable(),
    email: InquiryEntity.zSchema.shape.contacts.options[1].shape.email.nullable(),
    phone: InquiryEntity.zSchema.shape.contacts.options[0].shape.phone.nullable(),
  });
type OutSchema = z.infer<typeof zOutSchema>;

const zRes401 = Response.Schema.zUnsuccessful(401);

export {
  NUMBER_BY_SUBJECT,
  SUBJECT_BY_NUMBER,
  zOutSchema,
  zRes401,
  zSubjectAsNumber,
  zSubjectFromNumber,
};
export type { OutSchema };
